module.exports = __webpack_public_path__ + "static/media/HEART-2.980aeeb2.svg";